<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><em>To my mother, Joy King,</em><br/><em>for showing me how to treat people well</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062026323_epub_ded_r1.vue?39df8d98